"use strict";
/**
 * Using x-data-spreadsheet
 * By yuliang.liang(myliang)
 * MIT LICENSE
 * https://github.com/myliang/x-spreadsheet/blob/master/LICENSE
 *
 * **/
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var omi_1 = require("omi");
var x_data_spreadsheet_1 = require("x-data-spreadsheet");
//@ts-ignore
require("../theme.ts");
var Spreadsheet = /** @class */ (function (_super) {
    __extends(Spreadsheet, _super);
    function Spreadsheet() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Spreadsheet.prototype.installed = function () {
        var _this = this;
        var ele = this.shadowRoot.querySelector('.m-spreadsheet');
        document.body.appendChild(ele);
        var s = new x_data_spreadsheet_1.default(document.querySelector('.m-spreadsheet'), {
            view: {
                height: function () {
                    if (_this.props.height)
                        return _this.props.height;
                    return document.documentElement.clientHeight;
                },
                width: function () {
                    if (_this.props.width)
                        return _this.props.width;
                    return document.documentElement.clientWidth;
                }
            },
        })
            .loadData(this.props.data || {}) // load data
            .change(function (data) {
            _this.fire('change', data);
        });
        var placeholder = this.shadowRoot.querySelector('.placeholder');
        var rect = placeholder.getBoundingClientRect();
        //@ts-ignore
        ele.style.left = rect.left + 'px';
        //@ts-ignore
        ele.style.top = rect.top + 'px';
        // data validation
        s.validate();
        this.spreadsheet = s;
    };
    Spreadsheet.prototype.render = function (props) {
        return (omi_1.h("div", { class: "placeholder" },
            omi_1.h("div", { style: 'position: absolute;', class: "m-spreadsheet" })));
    };
    Spreadsheet.defaultProps = {};
    Spreadsheet.propTypes = {};
    Spreadsheet = __decorate([
        omi_1.tag('m-spreadsheet')
    ], Spreadsheet);
    return Spreadsheet;
}(omi_1.WeElement));
exports.default = Spreadsheet;
